import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IOqcValidationResultContract } from 'src/app/models/domain/oqc-validation-result';

export type EhdValidationFailedError = {
  type: 'ehdValidationFailed';
  message: string;
};

export type EhdErrorsError = {
  type: 'ehdErrors';
  errors: Array<{ row: number; message: string }>;
};

export type SubmitError = EhdErrorsError | EhdValidationFailedError | Error;

export function isEhdValidationError(err: unknown): err is EhdErrorsError {
  return (
    typeof err === 'object' &&
    !!err &&
    'type' in err &&
    (err as { type?: unknown }).type === 'ehdErrors'
  );
}

export function isEhdValidationFailedError(err: unknown): err is EhdValidationFailedError {
  return (
    typeof err === 'object' &&
    !!err &&
    'type' in err &&
    (err as { type?: unknown }).type === 'ehdValidationFailed'
  );
}

@Injectable({
  providedIn: 'root',
})
export class EhdValidationService {
  public constructor(private readonly httpClient: HttpClient) {}

  public validateEhd(designId: string): Observable<IOqcValidationResultContract> {
    return this.httpClient.get<IOqcValidationResultContract>(
      `api/validation/${designId}/ehd/errors`
    );
  }
}
